import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Client } from '../../model/client.modals'
import { AccessControlService } from 'src/app/services/access-control.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { AlertService } from 'src/app/services/alert.service';
import{ACCOUNTTYPES} from '../../model/types/Types'
import{USERTYPE} from "../../enum/roles.enum"

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.css']
})
export class AddClientComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private router: Router,
              private accessControlService: AccessControlService,
              private toasterService: ToastrService,
    private alertService: AlertService) { }
  title: any;
  buttonText: any;
  CrudMode: any;
  savingData = false;
  dropdownSettings = {
    singleSelection: false,
    idField: '_id',
    textField: 'application_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: false
  };
  clientId: any;
  client = new Client();
  applications: [] = [];
  applicationRequired = false;
  isLoading: boolean
  clients: {username:string,_id:string}[];
  createMode:ACCOUNTTYPES;
  ngOnInit() {
    this.isLoading = true
    this.applicationRequired = false
    let orgId = this.clientId = localStorage.getItem('org_id');
    this.fetchClientList();
    this.accessControlService.getOrganizationApps(orgId).subscribe((applications: []) => {
      this.applications = applications;
      if (this.router.url.indexOf('edit') == -1) this.isLoading = false
    })
    if (this.router.url.indexOf('edit') != -1) {
      this.clientId = this.activatedRoute.snapshot.params['id'];
      this.CrudMode = 2;
      this.buttonText = this.title = "Update"
      this.accessControlService.getClient(this.clientId, orgId).subscribe((res: any) => {
        if (!res.error)
          this.client = <Client>res.data;
          this.client.accounttype=this.createMode=res.data.type!==USERTYPE.SUBCLIENT?"NEW":"EXISTING";
          if(this.client.accounttype=="EXISTING")
          this.client.email="";
          this.client.exisitingUser=res.data.owner|| null;
          this.client.applications=this.client.applications.map(app=>{
            return app._id;
          });
        this.isLoading = false
      }, error => {
        this.isLoading = false
        this.toasterService.error(error);
      })


    } //edit
    else {
      this.client.accounttype="NEW";
      this.client.exisitingUser=null;
      this.client.email=null;
      this.CrudMode = 1
      this.buttonText = "Save";
      this.title = "Add"
    } //add

  }
  submit(form: NgForm) {
    if (form.invalid || this.client.applications.length <= 0 || form.pending) return
    this.applicationRequired = false
    this.savingData = true
    if (this.CrudMode == 1) {
      this.buttonText = "Saving..."
      this.client["_id"] = localStorage.getItem("org_id")
      this.client["created_By"] = localStorage.getItem("user_id")
      this.client['org_name'] = localStorage.getItem("org_name")
      this.accessControlService.saveClient(this.client).subscribe((response: any) => {
        this.savingData = false
        this.buttonText = "Save"
        if (!response.error) {
          if(response.data)
          this.alertService.updateAlert("This is your temporary password " + response.data);
          this.toasterService.success(response.message)
          this.router.navigate(['/clients'])
        }
        else {
          if ('emailTaken' in response) form.form.get('email').setErrors({ emailTaken: true })
          else this.toasterService.error(response.message)
        }
      }, error => {
        this.savingData = false
        this.buttonText = "Save"
        this.toasterService.error(error)
      })
    } else {
      this.buttonText = "Updating..."
      this.client["_id"] = localStorage.getItem("org_id");
      this.client["created_By"] = localStorage.getItem("user_id");
      this.client["clientId"] = this.clientId;
      this.accessControlService.updateClient(this.client).subscribe((response: any) => {
        this.savingData = false
        this.buttonText = "Update"
        if (!response.error) {
          this.toasterService.success(response.message);
          this.router.navigate(['/clients'])
        }
        else this.toasterService.error(response.message)
      }, error => {
        this.savingData = false
        this.buttonText = "Update"
        this.toasterService.error(error)
      })
    }
  }
  cancel() {
    this.router.navigate(['/clients'])
  }
  toggleDropDown() {
    if (this.client.applications.length <= 0) this.applicationRequired = true
    else this.applicationRequired = false
  }
  fetchClientList() {
    this.accessControlService.getOrganizationClients(this.clientId,0,Number.MAX_SAFE_INTEGER).subscribe((response: any) => {
      this.clients = Array.from(new Set<{username:string,_id:string}>(response.data.map(x=>{
        if(x.type!==USERTYPE.SUBCLIENT)
        return {username:x.username,_id:x._id};
      }))).filter(x=>{return typeof x=="object"});
    });
  }
}

